import { render, staticRenderFns } from "./android15.vue?vue&type=template&id=5419e0fe&scoped=true"
import script from "./android15.vue?vue&type=script&lang=js"
export * from "./android15.vue?vue&type=script&lang=js"
import style0 from "./android15.vue?vue&type=style&index=0&id=5419e0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419e0fe",
  null
  
)

export default component.exports